import { useEffect, useState } from 'react';

const diffParts = (ms) => ({
  days: Math.floor(ms / 86400000),
  hours: Math.floor((ms % 86400000) / 3600000),
  minutes: Math.floor((ms % 3600000) / 60000),
});

/**
 * status: 'upcoming' | 'ongoing' | 'finished'
 */
const useEventCountdown = (startISO, endISO) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(id);
  }, []);

  const start = new Date(startISO).getTime();
  const end = new Date(endISO).getTime();

  if (now >= end) return { status: 'finished', parts: null };
  if (now >= start) return { status: 'ongoing', parts: null };
  return { status: 'upcoming', parts: diffParts(start - now) };
};

export default useEventCountdown;
